import { render } from "./PCFooter.vue?vue&type=template&id=5d79e2b9&scoped=true"
import script from "./PCFooter.vue?vue&type=script&lang=js"
export * from "./PCFooter.vue?vue&type=script&lang=js"

import "./PCFooter.vue?vue&type=style&index=0&id=5d79e2b9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d79e2b9"]])

export default __exports__